<template>
  <modal 
    name="notepad-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'640px'"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen"
    @opened="opened">
    
    <div class="modal-header">
      <div class="modal-title">
        Notepad
      </div>

      <a href="#"
        @click.prevent="$modal.hide('notepad-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>
    
    <div class="modal-body">
      <template v-for="(note, index) in notes">
        <div class="mb-6">
          <div class="flex items-center">
            <div class="text-base">{{ note.page.charAt(0).toUpperCase() + note.page.substring(1) }}</div>
          </div>

          <div class="mt-2">
            <textarea
              class="w-full border border-gray-600 text-sm outline-none rounded p-3 focus:bg-yellow-200"
              :ref="note.page"
              style="height:100px;"
              :value="note.value"
              v-on:blur="saveNote({
                page : note.page,
                value: $event.target.value,
                index: index
              })" />
          </div>
        </div>
      </template>

      <div class="button-line">
        <SubmitButton2 :onClick="close" :loading="loading" label="Close" />
      </div>
    </div>
  </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'

  export default {

    components : {
      SubmitButton2
    },

    data() {
      return {
        client : null,
        notes  : null,
        loading: false
      }
    },

    methods : {

      close() {
        this.$modal.hide('notepad-modal')
      },
      
      beforeOpen(event) {
        this.loading = false

        this.client = event.params.client

        if(event.params.client.notes != null) {
          this.notes = JSON.parse(event.params.client.notes)
        }

        else {
          this.notes = [{
            page : 'applicants',
            value: null
          }, {
            page : 'requirements',
            value: null
          }, {
            page : 'assets',
            value: null
          }, {
            page : 'liabilities',
            value: null
          }, {
            page : 'living expenses',
            value: null
          }, {
            page : 'risk profile',
            value: null
          }, {
            page : 'documents',
            value: null
          }, {
            page : 'submit', 
            value: null
          }, {
            page : 'others',
            value: null
          }]
        }
      },

      opened(event) {
        // this.$refs.message.focus()
      },

      saveNote(params) {
        this.notes[params.index].value = params.value
        this.apiPost({
          clientId: this.client.id,
          notes   : this.notes,
        }, 'client/notes', (notes) => {
          EventBus.$emit('update-client-note', {
            clientId: this.client.id,
            notes   : notes.data
          })
        })
      }
    }
  }
</script>